import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59276484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title fs-5 fs-lg-4 text-center mb-5 pt-5" }
const _hoisted_2 = { class: "description container px-3 pb-5" }
const _hoisted_3 = { class: "row text-center" }
const _hoisted_4 = { class: "col-lg-12 justify-content-lg-end" }
const _hoisted_5 = { class: "d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const transitLogin = () => {
  router.push('/alumni/login')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(translate)('SC50title1')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('SC52changePasswordComplete')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Button, {
        title: _unref(translate)('login'),
        type: 'secondary',
        className: 'fw-bold',
        onClick: transitLogin
      }, null, 8, ["title"])
    ])
  ], 64))
}
}

})